import { ChangeEvent, useCallback, useState } from "react";
import {  searchCustomer } from "src/apis/customerApi";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { BRDiv } from "src/components/common/common";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { WMS2091_R01HeaderDto } from "./Dto_WMS2091_R01";
import { useWMS2091_R01Store } from "./Store_WMS2091_R01";
import { formatDate, validateString } from "src/utils/string/stringUtil";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";



interface Props {
	editable: boolean;
	defaultWMS2091_R01HeaderRow: WMS2091_R01HeaderDto;
}

export const Info_WMS2091_R01 = (props: Props) => {

	const {
		editable,
		defaultWMS2091_R01HeaderRow,
	} = props;

	// 
	const { inoutClassList, inoutMethodList, wmsCdList, compCdList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { 
			editWMS2091_R01, setEditWMS2091_R01,
			warehouseCdListToUseList,
	} = useWMS2091_R01Store();


	const custInfoHandleFoucsId = 'infoCustInput';
	const empInfoHandleFoucsId = 'infoEmpInput';

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
				telNo: 'telNo',
				faxNo: 'faxNo',
				moneyCd: 'moneyCd',
				taxEmail: 'email',
				post: 'post',
				address: 'address',
				detailAddress: 'otherAddress',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: editWMS2091_R01?.customCd || '',
				customNm: editWMS2091_R01?.customNm || '',
			}),
		},
		{
			fieldName: 'empNo',
			category: '담당자',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			},
			extraFilter: () => ({
				empNo: editWMS2091_R01?.empNo || '',
				empNm: editWMS2091_R01?.empNm || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editWMS2091_R01,
		setEditData: setEditWMS2091_R01,
		defaultData: defaultWMS2091_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS2091_R01'
	});

	// 입고일자 달력 팝업 상태
	const [salesPickerVisible, setSalesPickerVisible] = useState(false);
	const [salesPickerPos, setSalesPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	const handleDateChange = useCallback((field: keyof WMS2091_R01HeaderDto, value: any) => {
		setEditWMS2091_R01({
			...defaultWMS2091_R01HeaderRow,
			...editWMS2091_R01,
			[field]: value
		});
	}, [editWMS2091_R01]);

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		let additionalUpdates = {};
		// 입고물류(logicCenter)가 변경될 때, 해당 물류의 첫 번째 창고로 warehouseCd 자동 세팅
		if (name === 'logicCenter') {
			const availableWarehouses = warehouseCdListToUseList(value);
			additionalUpdates = {
				warehouseCd: availableWarehouses[0]?.warehouseCd || ''
			};
		}

		setEditWMS2091_R01({
			...defaultWMS2091_R01HeaderRow,
			...editWMS2091_R01,
			[name]: value,
			...additionalUpdates
		});
	}, [editWMS2091_R01, defaultWMS2091_R01HeaderRow, warehouseCdListToUseList]);

	return (
		<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300">
			<InputForm title="입고수불번호" value={editWMS2091_R01?.transportNo || ""}
				editable={false}
				name="transportNo"
				onChange={handleChange} />
			<BRDiv />

			<DropDownForm
				title="사업장"
				name="compCd"
				initLabelLess={true}
				value={editWMS2091_R01?.compCd}
				data={compCdList}
				editable={editable && !validateString(editWMS2091_R01?.transportNo || '')}
				onChange={handleChange}
			/>
			<SingleDateForm
				title="입고일자"
				value={editWMS2091_R01?.transportDt ? new Date(editWMS2091_R01.transportDt) : undefined}
				setValue={(value: Date | undefined) => handleDateChange('transportDt', formatDate(value))}
				editable={false}
				visible={salesPickerVisible} setVisible={setSalesPickerVisible}
				onChange={handleChange}
				pickerPos={salesPickerPos} setPickerPos={setSalesPickerPos}
			/>
			<BRDiv />

			<DropDownForm
				title="입고구분"
				name="inoutClass"
				initLabelLess={true}
				value={"100"}
				data={inoutClassList}
				editable={false}
				onChange={handleChange}
			/>
			<BRDiv />

			<CodeForm
				label="거래처"
				value={editWMS2091_R01?.customCd || ""}
				custNmValue={editWMS2091_R01?.customNm || ""}
				editable={editable && !validateString(editWMS2091_R01?.transportNo || '')}
				handleFoucsId={custInfoHandleFoucsId}
				name="customCd"
				handleChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>
			<CodeForm
				label="입고담당자"
				value={editWMS2091_R01?.empNo || ""}
				custNmValue={editWMS2091_R01?.empNm || ""}
				editable={editable && !validateString(editWMS2091_R01?.transportNo || '')}
				handleFoucsId={empInfoHandleFoucsId}
				name="empNo"
				handleChange={getFieldHandlers('empNo').onChange}
				onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
				onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
			/>
			<BRDiv />

			<DropDownForm<SysCodeDto>
				title="입고물류"
				data={wmsCdList}
				value={editWMS2091_R01?.logicCenter || ""}
				name="logicCenter"
				editable={editable && !validateString(editWMS2091_R01?.transportNo || '')}
				initLabelLess={true}
				onChange={handleChange} />
			<DropDownForm
				title="창고번호"
				name="warehouseCd"
				initLabelLess={true}
				value={editWMS2091_R01?.warehouseCd}
				data={warehouseCdListToUseList(editWMS2091_R01?.logicCenter || '')}
				editable={editable && !validateString(editWMS2091_R01?.transportNo || '')}
				onChange={handleChange}
			/>
			<BRDiv />

			<InputForm
				title="비고"
				value={editWMS2091_R01?.remark || ""}
				name="remark"
				editable={editable && !validateString(editWMS2091_R01?.transportNo || '')}
				wrapperOption={{
					wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[10px]",
					titleStyle: "w-[100px] min-w-[100px] text-left",
					inputStyle: "w-full min-w-full"
				}}
				onChange={handleChange}
			/>
		</div>
	)
}

